import { Route } from '@angular/router'
import { authGuard, groupTypeGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type CalendarRoutes = {
    calendar: Route
    clientCalendar: Route
}

export const calendarRoutes: CalendarRoutes = {
    calendar: {
        path: 'dashboard/calendar',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'vendor',
                redirectTo: ['/dashboard/client/calendar'],
            }),
            permissionGuard([PERMISSIONS.calendar.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-calendar/page-calendar.component').then(
                (m) => m.PageCalendarComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    clientCalendar: {
        path: 'dashboard/client/calendar',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'client',
                redirectTo: ['/dashboard/calendar'],
            }),
        ],
        loadComponent: () =>
            import('../page-calendar/page-calendar.component').then(
                (m) => m.PageCalendarComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },
}
